import { InvestmentObjectives, InvestmentObjectivesGetData } from '@interfaces/models';
import { createAction, props } from '@ngrx/store';

export const UPDATE_INVESTMENT_OBJECTIVES = '[Investment Objectives] Update';
export const TRANSFORM_OBJECTIVES_FROM_UI = '[Investment Objectives] Transform From UI';
export const RESET_INVESTMENT_OBJECTIVES = '[Investment Objectives] Reset';

export const UpdateInvestmentObjectives = createAction(
  UPDATE_INVESTMENT_OBJECTIVES,
  props<{ objectives?: Partial<InvestmentObjectives>; objectivesStatus?: boolean }>(),
);

export const TransformObjectivesFromUi = createAction(
  TRANSFORM_OBJECTIVES_FROM_UI,
  props<{ payload: Partial<InvestmentObjectivesGetData> }>(),
);

export const ResetInvestmentObjectives = createAction(RESET_INVESTMENT_OBJECTIVES);
